"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listInvoices = void 0;
const listInvoices = ({ httpClient, }) => ({ page = 1, per_page = 25, }) => {
    const path = '/customers/my/invoices';
    const query_params = { page, per_page };
    const url = `${path}`;
    return httpClient.get(url, { params: query_params });
};
exports.listInvoices = listInvoices;
//# sourceMappingURL=list-invoices.js.map